// extracted by mini-css-extract-plugin
export var actions = "_93-8";
export var arrow = "_93-5";
export var card = "_93-0";
export var cardWrapper = "_93-9";
export var fieldName = "_93-3";
export var newValue = "_93-6";
export var oldValue = "_93-4";
export var orangeGlowFade = "_93-c";
export var productSection = "_93-1";
export var scrollToBottom = "_93-b";
export var scrollToBottomAnchor = "_93-a";
export var scrollToBottomIcon = "_93-d";
export var showAllButton = "_93-7";
export var table = "_93-2";